<div class="row">
    <div class="col-md-6">
      <div class="mat-title titleColor font-weight-bold mb-1">Manage Your Dropbox Documents</div>
      <div class="mat-subheading-1 titleColor mb-1">Manage existing Dropbox documents</div>
    </div>
    <div class="col-md-6 d-flex justify-content-end">
      <input style="height: 1px; width: 1px; opacity:0; position: absolute; z-index: -1;" type="file" class="file-input" id="file-input" (change)="onFileSelected();" #fileUpload>
      <button *ngIf="isAuth" (click)="fileUpload.click()"
        class="im-btn ml-3 button_whitebg im-btn-with-icon im-btn-outline-primary im-btn-md">
        <i class="fa fa-upload im-drop-icon pt-1"></i> Upload Document
      </button>
      <button *ngIf="!isAuth" (click)="addDropBox();"
        class="im-btn ml-3 button_whitebg im-btn-with-icon im-btn-outline-primary im-btn-md">
        <i class="fa fa-plus im-drop-icon pt-1"></i> Connect DropBox
      </button>
      <button *ngIf="isAuth" (click)="getDropboxFiles();"
        class="im-btn ml-3 button_whitebg im-btn-with-icon im-btn-outline-primary im-btn-md">
        <i class="fa fa-refresh im-drop-icon pt-1"></i> Reload Documents
      </button>
    </div>
  </div>
  <div class="row mt-2" *ngIf="isAuth">
    <div class="mat-elevation-z8 bene-border w-100">
      <table class="table table-bordered table-hover" mat-table [dataSource]="dataSource" style="width: 100%;">
        <ng-container matColumnDef="sno">
          <th mat-header-cell *matHeaderCellDef><b>S No.</b></th>
          <td mat-cell *matCellDef="let i = index;"> {{i+1}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell class="col-fname" *matHeaderCellDef><b> File Name</b></th>
          <td mat-cell class="col-fname" *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="client_modified">
          <th mat-header-cell class="col-date" *matHeaderCellDef><b> Upload Date</b></th>
          <td mat-cell *matCellDef="let element"> {{element.client_modified | date: 'MM/dd/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="path_display">
          <th mat-header-cell class="col-path" *matHeaderCellDef><b> File Path</b></th>
          <td mat-cell class="col-path" *matCellDef="let element">
            <a class="link" href="javascript:void(0)" (click)="downloadDoc(element)">https://www.dropbox.com/...{{element.path_display}}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell class="col-action" *matHeaderCellDef><b> Action </b></th>
          <td mat-cell *matCellDef="let element">
            <div class="dropdown">
              <button class="btn dropDownOptions dropdown-toggle" type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-cog"></i>
              </button>
              <div class="dropdown-menu pull-right" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item enabled" (click)="downloadDoc(element)">Download</a>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <!-- <mat-paginator #paginator [pageSizeOptions]="[2, 4, 6]" showFirstLastButtons></mat-paginator>  -->
    </div>
  </div>
  
  